import React, { useEffect } from "react";
import SearchStringOrIntReq from "../../Classes/Models/Requests/SearchStringOrIntReq";
import SessionsApi from "../../Classes/API/Administration/SessionsApi";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import { useContext, useState } from "react";
import { UserContext } from "App";
import "./style.scss";

const AddmissionButton = ({ AccSession, setIsLoaded, onRefresh }) => {
  const User = useContext(UserContext);
  const [AccountingSession, setAccountingSession] = useState(AccSession);
  const [isSubmitting, setIsSubmitting] = useState(false); // الحالة الجديدة للمنع

  useEffect(() => {
    setAccountingSession(AccSession);
  }, [AccSession]);
  if (!User) {
    return <div>Loading...</div>;
  }
  if (
    (!["Admin", "Owner", "HeadAccounting"].includes(User.userType)) &&
    User.userType != "AccountingEmployee" &&
    User.userType != "Therapist" &&
    User.userType != "FloorManager" &&
    User.userType != "AppointmentEmployee" &&
    User.userType != "CallCenterEmployee" &&
    User.userType != "SubAdmin"
  ) {
    if (AccountingSession.isAdmitted == true) {
      return <span className="badge badge-success">Admitted</span>;
    } else {
      return <span className="badge badge-danger">Not Admitted</span>;
    }
  }

  const ToggleSessionAdmission = async (AccountingSession) => {
    if (isSubmitting) return;
    if (
      AccountingSession.isPaidFor &&
      AccountingSession.isAdmitted &&
      AccountingSession.isException
    ) {
      Swal.fire({
        title: "You cannot unadmit a paid exception.",
        text: "If you want to unadmit the patient, please remove the exception.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (
      AccountingSession.isAdmitted &&
      (!["Admin", "Owner", "HeadAccounting"].includes(User.userType)) &&
      User.userType != "SubAdmin"
    ) {
      Swal.fire({
        title: "Invalid Permission",
        text: "You are not allowed to un-admit this session",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    setIsSubmitting(true);

    Swal.fire({
      icon: "info",
      title: "Loading...",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let req = new SearchStringOrIntReq();
      req.SearchInt = AccountingSession.id;

      let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

      if (res.status == "Success") {
        console.log("res.data", res.data);
        Swal.fire("Success", res.message, "success");

        setAccountingSession(res.data);
        if (setIsLoaded) {
          setIsLoaded(false);
        }
        if (onRefresh) {
          onRefresh();
        }
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  let buttonText = "";
  let buttonClass = "";
  let buttonDisabled = false;

  if (AccountingSession.isAdmitted) {
    buttonText = "UnAdmit";
    buttonClass = "btn btn-dark";
  } else if (AccountingSession.isAdmittable == false) {
    buttonText = "UnAdmittable";
    buttonClass = "btn btn-info";
  }
  if (AccountingSession.isAbsent) {
    buttonText = "Absent";
    buttonClass = "btn btn-danger";
    buttonDisabled = true;
  }
  if (!AccountingSession.isPaidFor) {
    buttonClass = "btn btn-outline-danger";
    buttonDisabled = true;
    buttonText = "Not Paid";
  }
  if (
    !AccountingSession.isPaidFor &&
    AccountingSession.isAdmitted &&
    AccountingSession.isException
  ) {
    buttonClass = "btn btn-danger";
    buttonText = "UnAdmit (EXCEPTION - Not Paid)";
    buttonDisabled = false;
  }
  if (
    !AccountingSession.isPaidFor &&
    !AccountingSession.isAdmitted &&
    AccountingSession.isException
  ) {
    buttonClass = "btn btn-outline-danger";
    buttonText = "Admit (EXCEPTION - Not Paid)";
    buttonDisabled = false;
  }
  if (
    AccountingSession.isPaidFor &&
    !AccountingSession.isAdmitted &&
    AccountingSession.isException
  ) {
    buttonClass = "btn btn-outline-danger";
    buttonText = "Admit (EXCEPTION - Paid)";
    buttonDisabled = false;
  }
  if (
    AccountingSession.isPaidFor &&
    AccountingSession.isAdmitted &&
    AccountingSession.isException
  ) {
    buttonClass = "btn btn-outline-danger";
    buttonText = "UnAdmit (EXCEPTION - Paid)";
    buttonDisabled = false;
  } else {
    if (buttonText == "") {
      buttonText = "Admit";
      buttonClass = "btn btn-success";
    }
  }

  return (
    <MDTypography variant="button" fontWeight="regular" color="text">
      <button
        disabled={buttonDisabled || isSubmitting}
        onClick={() => ToggleSessionAdmission(AccountingSession)}
        className={buttonClass}
      >
        {isSubmitting ? "Wait..." : buttonText}
      </button>
    </MDTypography>
  );
};

export default AddmissionButton;
